import '../styles/Careers.scss';
import Header from '../components/Header';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import JobPreview from '../components/JobPreview';
import { useEffect, useState } from 'react';
import axios from 'axios';

const WorkCulture = `${process.env.REACT_APP_S3_URL}workCulture.svg`;
const Integration = `${process.env.REACT_APP_S3_URL}workLifeIntegration.svg`;
const Growth = `${process.env.REACT_APP_S3_URL}Growth.svg`;
const GroupPhoto = `${process.env.REACT_APP_S3_URL}groupPhoto.png`;
const CrossUpArrow = `${process.env.REACT_APP_S3_URL}RightArrowGrey.png`;
const LeftArrowBlack = `${process.env.REACT_APP_S3_URL}LeftArrowBlack.png`;
const RightArrowBlack = `${process.env.REACT_APP_S3_URL}rightArrowPink.png`;
const LeftArrowPink = `${process.env.REACT_APP_S3_URL}leftArrowPink.png`;
const RightArrowPink = `${process.env.REACT_APP_S3_URL}RightArrowPink.svg`;
const LeftArrowInActive = `${process.env.REACT_APP_S3_URL}LeftArrowBlack.svg`;
const LeftArrowActive = `${process.env.REACT_APP_S3_URL}LeftArrowPink.svg`;
const RightArrowInActive = `${process.env.REACT_APP_S3_URL}RightArrowBlack.svg`;
const RightArrowActive = `${process.env.REACT_APP_S3_URL}RightArrowPink.svg`;

const Careers = () => {
    const [jobs, setJobs] = useState([
        {
          "position": "Software Engineer",
          "qualification": "Bachelor's in Computer Science",
          "experience": "2-4 years"
        },
        {
          "position": "Data Analyst",
          "qualification": "Bachelor's in Statistics",
          "experience": "1-3 years"
        },
        {
          "position": "Project Manager",
          "qualification": "MBA in Project Management",
          "experience": "5-8 years"
        },
        {
          "position": "Frontend Developer",
          "qualification": "Bachelor's in Information Technology",
          "experience": "2-5 years"
        },
        {
          "position": "Backend Developer",
          "qualification": "Bachelor's in Software Engineering",
          "experience": "3-6 years"
        },
        {
          "position": "DevOps Engineer",
          "qualification": "Bachelor's in Computer Science",
          "experience": "4-7 years"
        },
        {
          "position": "Cybersecurity Specialist",
          "qualification": "Master's in Cybersecurity",
          "experience": "5-10 years"
        },
        {
          "position": "UI/UX Designer",
          "qualification": "Bachelor's in Graphic Design",
          "experience": "1-4 years"
        },
        {
          "position": "Machine Learning Engineer",
          "qualification": "Master's in Artificial Intelligence",
          "experience": "3-7 years"
        },
        {
          "position": "Cloud Architect",
          "qualification": "Bachelor's in Cloud Computing",
          "experience": "6-10 years"
        }
      ]
      );

    const [isOpen, setOpen] = useState(false);
    const [careerId, setCareerId] = useState('');
    
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 6; // Number of jobs per page
    const totalPages = Math.ceil(jobs.length / itemsPerPage);

    // Get jobs for the current page
    const currentJobs = jobs.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers for navigation
    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };
    
    const onClose = () => {
        setOpen(false);
    }

    useEffect(() => {

        axios.get(process.env.REACT_APP_BACKEND_URL + '/api/v1/careers')
            .then((response: any) => {
                console.log(response.data);
                setJobs(response.data);
            })
            .catch((error: any) => {
                console.error('Error fetching jobs:', error);
            });
    }, []);

    const JobPreviewAction = (careerId: string) => {
        setCareerId(careerId);
        setOpen(true);
    }

    return (
        <div>
            <div className="careers-container">
                <div className='careers-container-left'>
                    <div className="header-careers-section">
                        <h1 className="title">Careers</h1>
                        <p className="subtitle">
                        Expanding Rapidly, We're Always On The Lookout For Exceptional Talent To Join Our Team.
                        As Pioneers In Digital Payments, Our Career Opportunities Promise Excitement, Enjoyment, And Fulfillment.
                        </p>
                    </div>
                    {/* <div className='careers-container-right-mobile'>
                        <div className="slider-section">
                            <img src={GroupPhoto} alt="Gallery" className="slider-image" />
                            <p className="view-gallery">View Gallery</p>
                        </div>
                        <div className="pagination-section-mobile">
                            <img style={{cursor:'pointer'}} src={LeftArrowBlack} alt='Left Arrow'/>
                            <img style={{cursor:'pointer'}} src={RightArrowBlack} alt='Right Arrow'/>
                        </div>
                    </div> */}
                    {/* <hr style={{color: '#4B6B7B'}}/> */}
                    <div className="icon-section">
                        <div className="icon-container">
                        <img src={WorkCulture} alt="Empowering Work Culture" className="icon" />
                        <p className="icon-text">Empowering<br />Work Culture</p>
                        </div>
                        <div className="icon-container">
                        <img src={Integration}alt="Work Life Integration" className="icon" />
                        <p className="icon-text">Work Life<br />Integration</p>
                        </div>
                        <div className="icon-container">
                        <img src={Growth} alt="Professional Growth" className="icon" />
                        <p className="icon-text">Professional<br />Growth</p>
                        </div>
                    </div>
                </div>
                {/* <div className='careers-container-right'>
                    <div className="slider-section">
                        <img src={GroupPhoto} alt="Gallery" className="slider-image" />
                        <p className="view-gallery">View Gallery</p>
                        <div className='arrow-fix-left'>
                            <img src={LeftArrowPink} alt='' />
                        </div>
                        <div className='arrow-fix-right'>
                            <img src={RightArrowPink} alt='' />
                        </div>
                    </div>
                </div> */}
            </div>
            <div className='information-container'>
                <div className='information'>
                    <h3>
                        We Believe That The Heart Of Any Successful Company Is Its People, And Our Commitment To Fostering A <span style={{
                            background: 'linear-gradient(81.88deg, #E51A4B 0%, #E36F8A 107.04%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text', // For Firefox
                            color: 'transparent',
                          }}
                        >Vibrant And Inclusive</span> Workplace Is At The Core Of Everything We Do.
                    </h3>
                </div>
            </div>
            <div className="careers-listing-container">
                <div className='flexrow-between'>
                    <div className="header-section">
                        <h3 className="title">
                            Shape The <span
                                style={{
                                    background: 'linear-gradient(81.88deg, #E51A4B 0%, #E36F8A 107.04%)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    backgroundClip: 'text', // For Firefox
                                    color: 'transparent',
                                }}
                            >
                                Future
                            </span> <br /> Of Digital Payments
                        </h3>
                    </div>
                    <div className="pagination-section">
                        <img
                            style={{ cursor: 'pointer'}}
                            src={currentPage === 1 ? LeftArrowInActive : LeftArrowActive}
                            alt="Left Arrow"
                            onClick={handlePreviousPage}
                        />
                        <span className="page-indicator">{currentPage}/{totalPages}</span>
                        <img
                            style={{ cursor: 'pointer', opacity: currentPage === totalPages ? 0.5 : 1 }}
                            src={currentPage === totalPages ? RightArrowInActive : RightArrowActive}
                            alt="Right Arrow"
                            onClick={handleNextPage}
                        />
                    </div>
                </div>
                
                <div className="jobs-section">
                {currentJobs.map((job: any, index) => (
                    <div onClick={() => JobPreviewAction(job?.careerId)} className="job-card" key={index}>
                        <h3 className="job-position">Position</h3>
                        <p className="job-description">{job.position}</p>
                        <h4 className="job-qualification">Qualification</h4>
                        <p className="job-description">{job.qualification}</p>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                                <h4 className="job-experience">Experience</h4>
                                <p className="job-description">{job.experience}</p>
                            </div>
                            <div className="arrow">
                                <img src={CrossUpArrow} alt="Arrow" />
                            </div>
                        </div>
                    </div>
                    ))}
                </div>

                <div className="pagination-section-mobile">
                    <img style={{cursor:'pointer'}} src={currentPage === 1 ? LeftArrowInActive : LeftArrowActive} onClick={handlePreviousPage} alt='Left Arrow'/>
                    <span className="page-indicator">{currentPage}/{totalPages}</span>
                    <img style={{cursor:'pointer'}} src={currentPage === totalPages ? RightArrowInActive : RightArrowActive} onClick={handleNextPage} alt='Right Arrow'/>
                </div>
            </div>
            <ContactForm />
            <Footer />
            <JobPreview careerId={careerId} isOpen={isOpen} onClose={onClose}/>
        </div>
    )
}

export default Careers;